<template>
  <div>
      <div class="ckeckBox">
        <!-- <van-checkbox  shape="square" v-model="checked"></van-checkbox> -->
        <img v-if='checked' :src="require(`@/assets/img/${color=='green'?'dxxuanzhong':'dxxuanzhongblue'}.png`)" alt="" @click="changeCheck(false)">
        <img v-else :src="require('@/assets/img/dxweixuanzhong.png')" alt="" @click="handleSure">
        <div class="noticeText">
            勾选即代表我已阅读并同意
            <span v-if='merchant' @click="open('MERCHANT_TYPE')">《商户服务协议》</span>
            <span v-if='person' @click="open('PERSONAGE_TYPE')">《用户隐私政策》</span>
        </div>
      </div>
    <van-popup v-model="showModel">
      <div class="content">
        <div class="title">{{title}}</div>
        <div class="cont">
            <div v-html="content"></div>   
        </div>
        <div class="closeBox">
          <van-button round type="info"  @click="handleSure" size="small">已阅读并同意</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
 
<script>
import {getNowFormatDate} from '@/utils/common'
export default {
   props:['merchant','person','color'],

    data() {
        return {
            checked:false,
            showModel:false,
            results:[],
            title:'',
            content:'',

        }
    },
    created() {
      this.getData();
    },
    methods:{
          getData() {
            // 隐私授权类型  MERCHANT_TYPE=商户版
            //              PERSONAGE_TYPE=个人版
           
            this.request({
                baseURL: process.env.VUE_APP_PAY_URL,
                url:'/privacy_authorization_query',
                method:'post',
                data:['MERCHANT_TYPE','PERSONAGE_TYPE']
            }).then((res)=>{
                if (res.data.code == 1000) {
                    this.results = res.data.result;
                }
            })
        },
        open(type) {
            this.title = type=="MERCHANT_TYPE"?'商户服务协议':'用户隐私政策';
            this.showModel = true;
            this.results.forEach((item)=>{
                if (type == item.entitleType) {
                    this.content = item.entitleData;
                }
            })
        },
        changeCheck(e) {
            this.checked = e;
            this.$emit('getReadState',e,this.handleData());
        },

        handleData() {
            let details = [];
            this.results.forEach((item)=>{
                if ((this.merchant && item.entitleType == 'MERCHANT_TYPE') || (this.person && item.entitleType == 'PERSONAGE_TYPE')) {
                    let obj = {
                        entitleType:item.entitleType,
                        entitleVersion:item.entitleVersion,
                        entitleTime:getNowFormatDate(),
                    };
                    details.push(obj);
                }
            });
            return  details;
        },
        handleSure() {
            this.checked = true;
            this.$emit('getReadState',this.checked,this.handleData());
            this.showModel = false;
        }
    }
}
</script>

<style lang='scss' scoped>
    .ckeckBox {
        display: flex;
        padding: 10px;
         img {
           width: 18px;
           height: 18px;
         }
            .noticeText {
                letter-spacing: 0px;
                position: relative;
                top: 1px;
                margin-left: 5px;
                line-height: 20px;
                font-size: 12px;
            }
            span {
                color:#409EFF
            }
    }
.content {
  width: 80vw;
  padding: 10px;
  .title {
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .cont {
    font-size: 13px;
  }
}
.cont {
  max-height: 300px;
  min-height: 50px;
  overflow-y: scroll;
  >div {
    padding: 0 10px;
  }
}
.closeBox {
  padding-top: 10px;
  text-align: center;
}


</style>